import cx from 'classnames';
import {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {selectTextAreaOpen} from '~/CreateFabricInvitation/reducers/fabricDesign/selectors';
import {usePremiumFeatureBlocker} from '~/OneStepCreateInvitation/hooks/usePremiumFeatureBlocker';
import {Button} from '~library/atoms/Button';
import {ArrowIcon} from '~library/svg/ArrowIcon';

import './NavBottom.sass';

export const NavBottom = ({
  ctas,
  hideContinueButton,
  onClickBack,
  className,
  firstChild,
  grayedOut,
  innerRef,
  centered = false,
}) => {
  const {isUsingPremiumFeature, onBlockedElementClick} = usePremiumFeatureBlocker();
  const textAreaOpen = useSelector(selectTextAreaOpen);

  const renderNavBottomContent = useMemo(
    () => (
      <div className={cx(className, 'card-design__nav-bottom')} ref={innerRef}>
        {firstChild}
        {!hideContinueButton && !textAreaOpen && (
          // biome-ignore lint/a11y/noStaticElementInteractions: existing error
          // biome-ignore lint/a11y/useKeyWithClickEvents: existing error
          <div
            className={cx({
              'card-design__nav-bottom__cta_wrapper': true,
              'card-design__nav-bottom__cta_wrapper--centered': centered,
              'grayed-out': grayedOut,
            })}
            onClick={isUsingPremiumFeature ? onBlockedElementClick : null}
          >
            {onClickBack && (
              <Button
                className="nav-bottom__back-button"
                data-qa-id="nav-bottom-previous"
                variant="secondary"
                size="large"
                type="button"
                ariaLabel="Back"
                onClick={onClickBack}
              >
                <ArrowIcon direction="left" ratio={0.75} />
              </Button>
            )}
            {ctas && <div className="card-design__nav-bottom__ctas">{ctas}</div>}
          </div>
        )}
      </div>
    ),
    [
      className,
      innerRef,
      firstChild,
      hideContinueButton,
      textAreaOpen,
      centered,
      grayedOut,
      isUsingPremiumFeature,
      onBlockedElementClick,
      onClickBack,
      ctas,
    ]
  );

  return renderNavBottomContent;
};
